import { render, staticRenderFns } from "./CVendor.vue?vue&type=template&id=6afa1fea"
import script from "./CVendor.vue?vue&type=script&lang=js"
export * from "./CVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afa1fea')) {
      api.createRecord('6afa1fea', component.options)
    } else {
      api.reload('6afa1fea', component.options)
    }
    module.hot.accept("./CVendor.vue?vue&type=template&id=6afa1fea", function () {
      api.rerender('6afa1fea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CVendor.vue"
export default component.exports